import { TimeRangeContextType } from '../../../context/TimeRangeContext';
import { ChartPlotLine } from '../../../types/ChartPlotLine';

export type EChartPoint = [number, number | null];
export type EChartBandPoint = [number, number, number];

export const toEChartPoints = (rows: number[][]): EChartPoint[] =>
    rows.map((row): EChartPoint => [row[0], row[1] ?? null]);

export interface EChartTimeSeries {
    name: string;
    chartType: 'line' | 'bar' | 'area' | 'band';
    data: EChartPoint[] | EChartBandPoint[];
    color?: string;
    yAxisIndex?: 0 | 1;
    stack?: string;
    smooth?: boolean;
    fillOpacity?: number;
}

export interface EChartYAxis {
    labels?: boolean;
    name?: string;
    max?: number;
    position?: 'left' | 'right';
    format?: 'time' | 'number';
}

export interface EChartThreshold {
    value: number;
    color: string;
    label: string;
}

export interface TimeSeriesOptionArgs {
    series: EChartTimeSeries[];
    timeRangeContext: TimeRangeContextType;
    tooltipType: number;
    plotLines?: ChartPlotLine[];
    legend?: boolean;
    yAxis?: EChartYAxis[];
    thresholds?: EChartThreshold[];
    brush?: boolean;
    xExtent?: { min: number; max: number } | 'data';
    reverseStacks?: boolean;
    tooltipFormatter?: (params: any[]) => string;
}
